import React, { useEffect, useState } from 'react';

import Select from 'react-select';

const customStyles = {
  option: (provided, _state) => {
    return {
      ...provided,
    }
  },
  container: (provided, _state) => ({
    ...provided,
    '&:focus': {
      borderColor: "var(--cds-focus, #0099bb)",
      borderWidth: "2px"
    },
  }),
  control: (provided, _state) => ({
    // none of react-select's styles are passed to <Control />
    ...provided,
    borderRadius: 0,
    border: 0,
    backgroundColor: "#f4f4f4",
    borderBottom: "1px solid var(--cds-border-strong)",
    '&:focus': {
      borderColor: "var(--cds-focus, #0099bb)",
      borderWidth: "2px"
    },
  }),
  input: (provided, _state) => ({
    ...provided,
  }),
  multiValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    const backgroundColor = state.data.preSelected ? "hsl(0, 0%, 50%)" : "hsl(0, 0%, 90%)";
    return { ...provided, opacity, transition, backgroundColor};
  },
  multiValueLabel: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    const color = state.data.preSelected ? "var(--cds-text-on-color, #fff)": "var(--cds-text-primary, #161616)";
    const fontStyle = state.data.preSelected ? "italic" : "normal";
    return { ...provided, opacity, transition, color, fontStyle };
  }
}

const CustomSelect = ({selection = [], onSelectionChange = () => {}, items = [], placeholder = "auswählen...", isLoading = false, refToModal}) => {

  const [currentSelection, setSelection] = useState([]);

  useEffect(() => {
    console.info("setting selection:", selection);
    setSelection(selection);
  }, [selection]);

  const handleSelectionChange = (new_selection, action ) => {
    if (action.action === "clear") {
      onSelectionChange([]);
      return;
    }
    if (action.action === "remove-value") {
      //onSelectionChange(currentSelection.filter(e => e !== action.removedValue.value));
      onSelectionChange([]);
    } else {
      if (action.action === "select-option") {
        onSelectionChange([new_selection.value]);
      }
    }
  };
  console.info(document.getElementsByClassName("cds--modal"));

  return (
    <Select
      placeholder={placeholder}
      noOptionsMessage={() => "Wählen Sie"}
      isDisabled={isLoading}
      isLoading={isLoading}
      styles={customStyles}
      menuPlacement="bottom"
      menuPortalTarget={refToModal ? refToModal.current : document.body}
      menuPosition="fixed"
      classNamePrefix={"micast-custom-select"}
      onChange={handleSelectionChange}
      options={items}
      value={(currentSelection || []).map(current_id => {
        if (items && current_id) {
          const f = items.find(item => current_id === item.value);
          return f;
        }
      })}
    />
  )
}


export default CustomSelect;
